import createActions from 'utils/redux/createActions'

export default createActions([
  'STORE_LOGIN'
  , 'CLEAR_LOGIN'
], { category: 'login' })



// WEBPACK FOOTER //
// ./src/actions/login.js